import { render, staticRenderFns } from "./pastServeList.vue?vue&type=template&id=56e6d4ac&scoped=true&"
import script from "./pastServeList.vue?vue&type=script&lang=js&"
export * from "./pastServeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e6d4ac",
  null
  
)

export default component.exports